import { Comment } from '@ant-design/compatible';
import { BasketballEventType, UserBasic } from '@hefe/models';
import {
  BasketballEventAddCommentRequest,
  BasketballGamesSlice,
  BasketballPracticeAddCommentRequest,
  BasketballPracticesSlice,
} from '@hefe/store';
import { fullUserName } from '@hefe/utils';
import { Button, Dropdown, Form, Input, Space, Typography } from 'antd';
import { t } from 'i18next';
import { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { useAppDispatch } from '../../../../../../store/store';
import UserAvatar from '../../../../../core/components/user/user-avatar/user-avatar/user-avatar.component';
import styles from './event-details-comments-composer.component.module.scss';

interface EventDetailsCommentComposerComponentProps {
  eventType: BasketballEventType;
  eventId: number;
  teamId: number;
  users: UserBasic[];
}

export default function EventDetailsCommentComposerComponent(
  props: EventDetailsCommentComposerComponentProps
) {
  const dispatch = useAppDispatch();

  const [text, setText] = useState<string>('');
  const [activeUser, setActiveUser] = useState<UserBasic>(props.users[0]);
  const [isSaving, setSaving] = useState<boolean>(false);

  const sendComment = () => {
    setSaving(true);

    if (props.eventType === BasketballEventType.GAME) {
      const payload: BasketballEventAddCommentRequest = {
        team_id: props.teamId,
        text: text,
        user_id: activeUser.id,
      };

      dispatch(
        BasketballGamesSlice.addTeamCommentToGame({
          gameId: props.eventId,
          payload: payload,
        })
      )
        .unwrap()
        .catch(() => null)
        .then(() => setText(''))
        .finally(() => setSaving(false));
    }
    if (props.eventType === BasketballEventType.PRACTICE) {
      const payload: BasketballPracticeAddCommentRequest = {
        text: text,
        user_id: activeUser.id,
      };

      dispatch(
        BasketballPracticesSlice.addCommentToPractice({
          practiceId: props.eventId,
          payload: payload,
        })
      )
        .unwrap()
        .catch(() => null)
        .then(() => setText(''))
        .finally(() => setSaving(false));
    }
  };

  if (!activeUser) {
    return <></>;
  }

  return (
    <Comment
      avatar={<UserAvatar user={activeUser} withTooltip size="default" />}
      content={
        <div>
          <Form.Item>
            <Input.TextArea
              rows={4}
              onChange={(event) => setText(event.target.value)}
              value={text}
            />
          </Form.Item>
          <Space>
            <Button
              htmlType="submit"
              loading={isSaving}
              onClick={() => sendComment()}
              type="primary"
            >
              {t('save')}
            </Button>
            <Space>
              <Typography.Text>{t('comments.comment_as')} </Typography.Text>
              <Dropdown
                trigger={['click']}
                menu={{
                  items: props.users.map((user) => {
                    return {
                      label: fullUserName(user),
                      key: user.id,
                      onClick: () => setActiveUser(user),
                    };
                  }),
                }}
              >
                <Typography.Text className={styles['user-dropdown']}>
                  {activeUser.firstname} {activeUser.lastname}{' '}
                  <FiChevronDown size={12} />
                </Typography.Text>
              </Dropdown>
            </Space>
          </Space>
        </div>
      }
    />
  );
}
